// extracted by mini-css-extract-plugin
export default {"wrapper":"_x-z","viewport":"ay-z","container":"by-z","slide":"cy-z"};